// Time Marker format: mm:ss
export const getSeconds = (timemarker = "00:00") => {
  if (timemarker) {
    const marker = timemarker.split(":").reverse();
    const reducer = (acc, curVal, index) => {
      return acc + 60 ** index * parseInt(curVal, 10);
    };
    return marker.reduce(reducer, 0);
  }
  return 0;
};

export default {
  getSeconds,
};
